<div id="main-content">
    <div class="container-fluid">
        <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingHistory"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="changeOccured">
              <table id="all-state-zones" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>S/N</th>
                  <th>Processed Date</th>
                  <th>Description</th>
                  <th>Total Amount</th>
                  <th>Transaction Ref</th>
                  <th>Action</th>
                  <th>Status</th>
                  <th>Total Beneficiaries</th>
                  <th>Pending Beneficiaries</th>
                  <th>Failed Beneficiaries</th>
                  <th>Successful Beneficiaries</th>
                  <th>Source Bank Name</th>
                  <th>Source Account Name</th>
                  <th>Source Account Number</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>S/N</th>
                  <th>Processed Date</th>
                  <th>Description</th>
                  <th>Total Amount</th>
                  <th>Transaction Ref</th>
                  <th>Action</th>
                  <th>Status</th>
                  <th>Total Beneficiaries</th>
                  <th>Pending Beneficiaries</th>
                  <th>Failed Beneficiaries</th>
                  <th>Successful Beneficiaries</th>
                  <th>Source Bank Name</th>
                  <th>Source Account Name</th>
                  <th>Source Account Number</th>
                </tr>
                </tfoot>
                <tbody>
                <tr *ngFor="let h of history;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{h.processed_at}}</td>
                  <td>{{h.description}}</td>
                  <th>{{ h?.total_amount || 0 | currency: '&#8358;' }}</th>
                  <td>{{ h?.transaction_ref }}</td>
                  <td>
                      <span role="button"  data-balloon="View Details" data-balloon-pos="up" (click)="viewLines(h)">
                        <i class="fa fa-eye text-info"></i>
                      </span>
                  </td>
                 <td>{{ h?.status | titlecase }}</td>
                 <td>{{ h?.total_beneficiaries }}</td>
                 <td>{{ h?.pending_beneficiaries ?? '--' }}</td>
                 <td>{{ h?.failed_beneficiaries ?? '--' }}</td>
                 <td>{{ h?.successful_beneficiaries ?? '--' }}</td>
                 <td>{{ h?.source_bankname ?? '--' }}</td>
                 <td>{{ h?.source_account_name ?? '--' }}</td>
                 <td>{{ h?.source_accno ?? '--' }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
</div>
<app-modal [modalId]="'lineModal'" [modalTitle]="'Settlement Lines'" [modalSize]="'lg'" >
        <div class="card">
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="ViewingSettlement"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="hasChanged">
              <table id="line" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>S/N</th>
                  <th>Category</th>
                  <th>Zone</th>
                  <th>Amount</th>
                  <th>Account Number</th>
                  <th>Bank Name</th>
                  <th>Account Name</th>
                  <th>Status</th>
                  <th>Serial Number</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>S/N</th>
                  <th>Category</th>
                  <th>Zone</th>
                  <th>Amount</th>
                  <th>Account Number</th>
                  <th>Bank Name</th>
                  <th>Account Name</th>
                  <th>Status</th>
                  <th>Serial Number</th>
                </tr>
                </tfoot>
                <tbody>
                <tr *ngFor="let l of settlementLines;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{l.category | titlecase}}</td>
                  <td>{{l.zone ?? '--' | titlecase}}</td>
                  <th>{{ l?.total_amount || 0 | currency: '&#8358;' }}</th>
                  <td>{{ l?.account_name }}</td>
                  <td>{{l?.bank_name}}</td>
                 <td>{{ l?.account_name}}</td>
                 <td>
                  <small class="badge bg-transparent" [ngClass]="{' border border-success text-success': l.status.toLowerCase() === 'success', 
                  ' border border-danger text-danger': l.status.toLowerCase() === 'failed', ' border border-warning text-warning': l.status.toLowerCase() === 'pending'
                }" >{{l.status | titlecase}}</small>
                 </td>
                 <td>{{l?.serial_no}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
  <div class="modal-footer">
    <button (click)="closeModal()" class="btn btn-danger">Close</button>
  </div>
</app-modal>
